import { WSFileAccessScope } from "@wingspanhq/files/dist/lib/interfaces";
import { useMutationDownloadFile } from "../../../query/files/mutations";

export const useFileDownload = () => {
  const [downloadFile, downloadFileMeta] = useMutationDownloadFile();

  const download = async (
    fileId: string,
    accessScope = WSFileAccessScope.Private
  ) => {
    await downloadFile({ accessScope, fileId });
  };

  return { download, isLoading: downloadFileMeta.isLoading };
};
